import script from "./RegistrationComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationComplete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__